import { useMemo } from "react";
import { t } from "@/i18n-js/instance";
import type { Appearance } from "../../Store/interfaceSlice";
import type { SiteTheme } from "../constants";

interface ThemeOptionLabelProps {
  appearance: Appearance;
  theme: SiteTheme;
}

export const ThemeOptionLabel = ({
  theme,
  appearance,
}: ThemeOptionLabelProps) => {
  const swatches = useMemo(
    () =>
      Object.entries(theme.cssVariables[appearance])
        .filter(([key]) => key.startsWith("theme-website-color-"))
        .slice(0, 6)
        .map(([, value]) => value),
    [theme, appearance],
  );

  return (
    <div className="flex w-full items-center gap-1.5">
      <div className="flex items-center gap-1">
        {swatches.map(color => (
          <span
            key={color}
            style={{ backgroundColor: color }}
            className="border-primary -ml-2 h-4 w-4 rounded-[5px] border"
          />
        ))}
      </div>
      <span className="text-sm font-medium">
        {t(`builder_ui.theme_configuration.themes_list.${theme.value}.title`)}
      </span>
    </div>
  );
};
